import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MaterialModule } from '../../_shared';

@Component({
  selector: 'app-page-not-found',
  imports: [MaterialModule],
  templateUrl: './page-not-found.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './page-not-found.scss',
})
export class PageNotFound {

}
